import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FileSizePipe } from '../../../../sdk/pipes';
import { UploadFile, ViewFile } from '../file-uploader.model';

@Component({
  selector: 'rms-file-uploader-item',
  imports: [FileSizePipe, MatIcon, TranslateModule, MatTooltip, NgClass, MatIconButton, MatProgressSpinner],
  templateUrl: './file-uploader-item.component.html',
})
export class FileUploaderItemComponent {
  @Input({ required: true }) public file!: UploadFile | ViewFile;
  @Input() public disabled = false;
  @Input() public fileIcon: string | null = null;

  @Input() public allowEdit = false;
  @Input() public editDisabled = false;
  @Input() public editLoading = false;

  @Input() public allowDelete = true;
  @Input() public deleteDisabled = false;
  @Input() public deleteLoading = false;

  @Input() public downloadLoading = false;

  @Input() public invalid = false;

  @Output() public delete = new EventEmitter<void>();
  @Output() public edit = new EventEmitter<void>();
  @Output() public download = new EventEmitter<void>();

  protected get url(): string | null {
    return this.file.hasOwnProperty('url') ? (this.file as ViewFile).url : null;
  }

  protected get error(): string | null {
    return this.file.hasOwnProperty('error') ? ((this.file as UploadFile).error ?? '') : null;
  }
}
